/**
 * Optional hook executed by <place-order> before the order is submitted.
 * Used by the theme checkout to save the inline address form when "place order" is clicked.
 *
 * The hook receives the result of the regular checkout validation and returns a Promise<boolean>:
 * true = continue with the regular order process, false = stop.
 * Kept outside of the vuex store on purpose, so only the checkout bundle is affected.
 */
let _beforePlaceOrder = null;

export function setBeforePlaceOrder(hook)
{
    _beforePlaceOrder = typeof hook === "function" ? hook : null;
}

export function getBeforePlaceOrder()
{
    return _beforePlaceOrder;
}
